import { withCompass } from "@faire/prototype-playground/components/compass/withCompass";

export { prototypeMeta } from "./meta";

export default withCompass(() => import("./Page"));
